import React, { useContext, useEffect, useState, lazy, Suspense } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components/macro';

import { cookieDomain } from '@mirinae/shared/defines/paths';

import { UserAgent } from '@mirinae/js-utils';
import { Layout, size, breakPoint } from '@mirinae/react-ui';

import LessonRoutes from './lessonsRoutes';

import HeaderContainer from '@mirinae/lessons/containers/common/HeaderContainer';
import FooterContainer from '@mirinae/lessons/containers/common/FooterContainer';
import LoadingSpinner from '@mirinae/react-ui/components/spinner/LoadingSpinner';

import ContentsLayout from '@mirinae/lessons/components/layout/ContentsLayout';
import { elementComponents, getElementComponent } from '@mirinae/lessons/components/lesson/elementComponentMap';
import { pageComponents, getPageComponent } from '@mirinae/lessons/components/lesson/pageComponentMap';
import GlobalContext, { useGlobalContext } from '@mirinae/lessons/modules/contexts/global';
import LessonsContext, { useLessonsContext } from '@mirinae/lessons/modules/contexts/lessons';
import PlayerContext, { usePlayerContext } from '@mirinae/lessons/modules/contexts/player';
import { authPaths, lessonsPaths, navigateExternal } from '@mirinae/shared/defines/paths';

import { useAppVersionStore } from '@mirinae/shared/stores/appVersion';
import { UserContext } from '@mirinae/react-auth';
import UpgradeToPP2AppPopup from '@mirinae/lessons/components/modal/UpgradeToPP2AppPopup';
import UpgradeProPopup from '@explorer/components/pro/UpgradeProPopup';
import { useProAccessStore } from '@mirinae/stores/proAccessStore';

const Editor = lazy(() => import(/* webpackChunkName: "Editor" */ './editor/Editor'));
const FeedbackContainer = lazy(() => import(/* webpackChunkName: "FeedbackContainer" */ '@mirinae/lessons/containers/feedback/FeedbackContainer'));

const EditorAndPlayerContainer = styled.div`
    // min-height: calc(100vh - ${size.header});
    // min-height: 100vh;
    /* max-width: ${size.wrap}; */
    // max-width: 760px;
    margin: 0 ${props => (props.isAdminPage ? '20px' : 'auto')};
    // padding: 0 20px 80px;
`;

const Lessons = () => {
    const { os } = UserAgent;
    const navigate = useNavigate();
    const { appVersion, isProEnabledVersion, displayMustUpgradeApp } = useAppVersionStore();
    const [ userContext, _ ] = useContext(UserContext);
    const displayUpgradeToPro = useProAccessStore(state => state.displayUpgradeToPro);
    const { user } = userContext;

    const componentMap = { elementComponents, getElementComponent, pageComponents, getPageComponent };
    const global = useGlobalContext(appVersion, isProEnabledVersion);
    const playerContext = usePlayerContext(userContext, global, componentMap);
    const lessonsContext = useLessonsContext();

    // const [ cookies, setCookie ] = useCookies(['lessonfirst']);
    // const [ passByLanding, setPassByLanding ] = useState(false);

    // we should let guest users see the lesson landing page & then ask for registration on clicking start there
    // useEffect(() => {
    //     if (!user || user?.role === 'guest') {
    //         navigateExternal(`${authPaths.login}?redirect=${lessonsPaths.overview}`, { replace: true });
    //     }
    // }, [user?.role]);

    const isAdminPage = window.location.pathname.match(/admin/);

    // const isLanding = () => window.location.pathname.match(/\/lessons($|\/$)|landing($|\/$)|\/question($|\/$)/)?.length > 0;
    // const isPassByLanding = () => isLanding() && cookies['lessonfirst'] === 'true';

    const [ cookies, setCookie ] = useCookies(['lessonfirst']);

    const isLandingPath = () => window.location.pathname.match(/\/lessons($|\/$)|landing($|\/$)|\/question($|\/$)/)?.length > 0;
    const isPassByLanding = () => isLandingPath() && cookies['lessonfirst'] === 'true' && !lessonsContext.guestMode();
    
    // useEffect(() => {
    //     // setPassByLanding(isPassByLanding());
    //     if(isPassByLanding()) {
    //         navigateExternal(`${lessonsPaths.overview}`, { replace: true });
    //     }
    // }, [window.location.pathname]);

    useEffect(() => {
        document.body.id = "lessons-app-root";
        lessonsContext.loadLessonLists();
    }, []);

    const showEditor = () => {
        const show =  Boolean(
            (global.showEditor || window.location.search.match(/edit=1/))
            && os.isOthers
            && user && user.role
            && user.role.match(/admin|superadmin|superuser|lessoneditor|lessoncreator/i),
        );
        console.log({showEditor: show});
        return show;
    };

    return (
        // <StylesProvider injectLast>
            <GlobalContext.Provider value={global}>
                <PlayerContext.Provider value={playerContext}>
                    <LessonsContext.Provider value={lessonsContext}>
                        <Layout>
                            <ContentsLayout>
                                <HeaderContainer mode="lessons" />
                                <EditorAndPlayerContainer isAdminPage={isAdminPage}>
                                    { global.currentLessonObject && showEditor() && (
                                        <Suspense fallback={LoadingSpinner}>
                                            <Editor />
                                        </Suspense>
                                    )}
                                    <LessonRoutes isPassByLanding={isPassByLanding()} />
                                </EditorAndPlayerContainer>
                            </ContentsLayout>
                            {/* upgrade pro popup */}{ displayUpgradeToPro && <UpgradeProPopup user={user} /> }
                            {/* must upgrade app popup */}{ displayMustUpgradeApp && <UpgradeToPP2AppPopup /> }
                            { global.displayFeedback === 1 && <FeedbackContainer />}
                        </Layout>
                        <FooterContainer />
                    </LessonsContext.Provider>
                </PlayerContext.Provider>
            </GlobalContext.Provider>
        // </StylesProvider>
    );
};

export default Lessons;
